import React, { useState,useEffect } from 'react';
import {useAppDispatch,useAppSelector} from '@/store/hooks';
import { clearYourTownloopSearchValue } from '@/store/slices/searchBarSlice';
import { Tabs,Button,Space ,App,Pagination  } from 'antd';
import { eventBus } from '@/utils/eventBus';
import { useSearchParams } from 'react-router-dom';
import YourTownloopOrdersList from '../../components/YourTownloopOrdersList/YourTownloopOrdersList';
import styles from './YourOrders.module.scss';
import iocn2 from '@/assets/images/组件 2 – 2@2x.png';
import OrderServicePanel from '../../components/OrderServicePanel/OrderServicePanel';
import RefundOnly from '../../components/RefundOnly/RefundOnly';
import RefundAndReturn from '../../components/RefundAndReturn/RefundAndReturn';
import { getOrderAllList,getOrderPageList,getOrderByKeyword, getOrderById } from '@/api/order';
import { orderStatusOptionsMapper } from '@/utils/constants';
import { useTranslation } from 'react-i18next';
// 接口返回的订单数据类型
interface Spec {
  lable: string;
  value: string;
  product_base_attribute_id: number;
  is_custom_attribute?: boolean;
}

interface ProductSku {
  product_sku_id: string;
  product_price: string;
  product_stock: number;
  brand_name: string;
  product_spu_name: string;
  specs: Spec[];
}

interface OrderItem {
  product_order: any;
  order_item_id: number;
  product_order_item_id: string;
  product: {
    product_id: string;
    product_title: string;
    product_media_list: Array<{
      product_media_file_url: string;
    }>;
  };
  product_sku: ProductSku;
  product_item_title: string;
  product_item_price: string;
  product_item_quantity: number;
}

interface OrderData {
  update_time: string;
  parent_order: {
    order_id: string;
  };
  product_order_id: string;
  product_order_refund:{product_order_refund_status:number} | null;
  product_order_total_price: string;
  product_order_status: number;
  order_payment_method: string;
  created_time: string;
  order_item_list: OrderItem[];
}

interface OrderListResponse {
  code: number;
  message: string;
  data: OrderData[];
  total: number;
  totalPages: number;
  pageNum: number;
  pageSize: number;
}

// 转换后的订单类型
interface TransformedOrder {
  odId: string;
  id: string;
  date: string;
  orderNumber: string;
  store: string;
  status: string;
  order_status: number;
  product_order_refund: {product_order_refund_status:number} | null;
  products: Array<{
    id: string;
    product_id: string;
    product_sku_id: string;
    img: string;
    title: string;
    specs: Spec[];
    price: string;
    quantity: number;
    product_order_id: string;
    subtotalPrice: string;
  }>;
  paidAmount: string;
  shippingFee: string;
  is_delete?: boolean;
}

//tabItems切换 
const generateTabItems = (t: (key: string) => string) => {
  const orderStatusOptions = orderStatusOptionsMapper();
  const tabItems = [
    { label: t('common.All'), key: 'all' },
    ...orderStatusOptions.map(option => ({
      label: t('yourorders.'+option.label),
      key: option.value.toString()
    }))
  ];
  
  return tabItems;
};



// 订单状态映射 - 使用枚举
const getOrderStatusText = (status: number): string => {
  const orderStatusOptions = orderStatusOptionsMapper();
  const statusOption = orderStatusOptions.find(option => option.value === status);
  return statusOption?.label || 'Unknown Status';
};

const YourOrders: React.FC = () => {
  const { t, i18n } = useTranslation();
  const tabItems = generateTabItems(t);
  const {message} = App.useApp();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
   //tab切换
   const [activeTab, setActiveTab] = useState('all');
   
   // 订单数据状态
   const [orders, setOrders] = useState<TransformedOrder[]>([]);
   const [loading, setLoading] = useState(false);
   const [pagination, setPagination] = useState({
     current: 1,
     pageSize: 10,
     total: 0,
     totalPages: 0
   });

  //切换tab事件
  const changeTab = (key: string) => {
    console.log('key',key);
    setActiveTab(key);
    // 切换tab时重新获取数据，传递order_status参数
    const orderStatus = key === 'all' ? undefined : parseInt(key);
    getOrderPageListData(1, pagination.pageSize, orderStatus);
  }

  //消息列表关键字搜索
  const [searchValue, setSearchValue] = useState<string>('');

  const searchAction = () => {
    console.log('searchValue',searchValue);


    // // 如果搜索框为空，获取所有订单列表
    const orderStatus = activeTab === 'all' ? undefined : parseInt(activeTab);
    getOrderPageListData(1, pagination.pageSize, orderStatus,searchValue.trim());



   
  }

  // 搜索消息列表处理键盘回车事件
  const searchHandleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      searchAction();
    }
  }

  // 转换接口数据为组件需要的格式
  const transformOrderData = (orderData: OrderData): TransformedOrder => {
    const orderItems = orderData.order_item_list;
    
    // 获取第一个商品的图片
    const firstProduct = orderItems[0] || {product: {product_media_list: [],product_title: ''}};
    
    
    return {
      id: orderData.product_order_id,
      product_order_refund: orderData.product_order_refund,
      date: orderData.update_time,
      orderNumber: orderData.product_order_id,
      odId: orderData.parent_order?.order_id || '',
      store: firstProduct.product.product_title || '',
      status: getOrderStatusText(orderData.product_order_status),
      order_status: orderData.product_order_status, // 添加原始订单状态数字
      products: orderItems.map(item => ({
        product_order_id:item?.product_order.product_order_id,
        id: item.product_order_item_id.toString(),
        product_id: item.product.product_id,
        product_sku_id: item.product_sku.product_sku_id,
        img: item.product.product_media_list?.[0]?.product_media_file_url || '',
        title: item.product_item_title,
        specs: item.product_sku.specs,
        price: item.product_item_price,
        quantity: item.product_item_quantity,
        subtotalPrice: (Number(item.product_item_price) * Number(item.product_item_quantity)).toFixed(2),
      })),
      paidAmount: orderData.product_order_total_price,
        shippingFee: '0.00',
         is_delete: false  
    };
  };

  //获取商品id
  const [showServicePanel, setShowServicePanel] = useState(false);
  const [serviceOrder, setServiceOrder] = useState<TransformedOrder | null>(null);
  const [serviceStep, setServiceStep] = useState('select');
  const [orderDetailData, setOrderDetailData] = useState<any | null>(null);

  const getId = (id: string, action: string) => {
    if (action === 'service') {
      const order = orders.find(o => o.id === id);
      setServiceOrder(order || null);
      setShowServicePanel(true);
      return;
    }
    if(action === 'delete'){
      // 删除成功后重新获取列表数据
      const orderStatus = activeTab === 'all' ? undefined : parseInt(activeTab);
      getOrderPageListData(1, pagination.pageSize, orderStatus);
      
    }else if(action === 'cancel' || action === 'refund'){
      const orderStatus = activeTab === 'all' ? undefined : parseInt(activeTab);
      getOrderPageListData(pagination.current, pagination.pageSize, orderStatus);
    }
  }

  //分页change
  const paginationChange = (page: number, pageSize: number) => {
    console.log('page', page, pageSize);
    // 分页时保持当前tab状态
    const orderStatus = activeTab === 'all' ? undefined : parseInt(activeTab);
    getOrderPageListData(page, pageSize, orderStatus);
  }
  
  
  

  const handleSelectServiceType = (type: 'refundOnly' | 'refundAndReturn') => {
    if (serviceOrder?.products?.[0]?.product_order_id) {
      const productOrderId = serviceOrder.products[0].product_order_id;
      getOrderById(productOrderId).then((res: any) => {
        if (res.code === 200) {
          setOrderDetailData(res.data);
        } else {
          message.error(res.message || t("yourorders.Failedgetorderdetails"));
        }
      }).catch((error: any) => {
        console.error('Failed to get order details:', error);
        message.error(t("yourorders.Failedgetorderdetails"));
      });
    }
    if (type === 'refundOnly') setServiceStep('refundOnly');
    else setServiceStep('refundAndReturn');
  };

  //获取订单页列表
  const getOrderPageListData = (
    pageNum: number = 1, 
    pageSize: number = 10, 
    orderStatus?: number,
    keyword?:string
  ) => {
    setLoading(true);


    const params: any = {page_num: pageNum, page_size: pageSize};

    if (orderStatus !== undefined) {
      params.order_status = orderStatus;
    }

    if (keyword !== undefined) {
      params.keyword = keyword;
    }


    getOrderPageList(params).then((res: OrderListResponse) => {
   
      console.log(res, 'getOrderPageListData');
      if (res.code === 200) {
        // 转换数据格式
        const transformedOrders = res.data.map(transformOrderData);

        console.log('transformedOrders',transformedOrders);
        
        setOrders(transformedOrders);
        setPagination({
          current: res.pageNum,
          pageSize: res.pageSize,
          total: res.total,
          totalPages: res.totalPages
        });
      } else {
        message.error(res.message || t("yourorders.Failedgetorderlist"));
      }
    }).catch((error) => {
      console.error('Failed to get order list:', error);
      message.error(t("yourorders.Failedgetorderlist"));
    }).finally(() => {
      setLoading(false);
    });
  }


  // 根据URL参数初始化tab状态
  useEffect(() => {
    const statusParam = searchParams.get('status');
    if (statusParam) {
      // 验证status参数是否有效
      const validStatuses = ['1', '2', '3', '5'];
      if (validStatuses.includes(statusParam)) {
        setActiveTab(statusParam);
        getOrderPageListData(1, pagination.pageSize, parseInt(statusParam));
      } else {
        setActiveTab('all');
        getOrderPageListData(1, pagination.pageSize, undefined);
      }
    } else {
      setActiveTab('all');
      getOrderPageListData(1, pagination.pageSize, undefined);
    }
  }, [searchParams]);

  //mounted 和unmounted
  useEffect(()=>{
    return ()=>{
    }
  },[]);

  


  return (
    <div className={styles['order-box']}>
      {!showServicePanel && (
        <div className={styles['left-panel']}>
          <Tabs
            className={styles['favorites-tabs']}
            items={tabItems}
            activeKey={activeTab}
            onChange={changeTab}
          />
          <div className={styles['search-btn-box']}>
            <div className={styles['sidebar-search']}>
              <input
                value={searchValue}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchValue(e.target.value)}
                onKeyDown={searchHandleKeyDown}
                type="text"
                placeholder={t("yourorders.Enterproductinformation")}
              />
              <img src={iocn2} alt="" onClick={searchAction}/>
            </div>
            <Button className={styles['search-btn']} onClick={searchAction}>{t('common.Search')}</Button>
          </div>
          <YourTownloopOrdersList orders={orders} getId={getId}/>
          <div className={styles['pagination-box']}>
            <Pagination 
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
              onChange={paginationChange}
              showSizeChanger={false}
              showQuickJumper
              showTotal={(total, range) => `${t('common.Items')} ${range[0]}-${range[1]} ${t('common.Total')}: ${total} `}
            />
          </div>
        </div>
      )}
      {showServicePanel && serviceOrder && (
        <div className={styles['right-panel']}>
          {serviceStep === 'select' && (
            <OrderServicePanel
              order={serviceOrder}
              onClose={() => { setShowServicePanel(false); setServiceStep('select'); }}
              onSelectServiceType={handleSelectServiceType}
            />
          )}
          {serviceStep === 'refundOnly' && (
            <RefundOnly order={serviceOrder} onBack={() => setServiceStep('select')} serviceType="refundOnly" orderDetail={orderDetailData} />
          )}
          {serviceStep === 'refundAndReturn' && (
            <RefundOnly order={serviceOrder} onBack={() => setServiceStep('select')} serviceType="refundAndReturn" orderDetail={orderDetailData} />
          )}
        </div>
      )}
    </div>
  );
};

export default YourOrders; 